import React from 'react';
import { Dropdown } from '@insurancemenu/imenu-components-lib';
import { ChevronDown, ChevronUp } from '@insurancemenu/imenu-components-lib/dist/icons';
import { DropdownOptionType, OptionsAlignmentTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { observer } from 'mobx-react-lite';
import { useWelcomeKitPageStore } from 'store/pages/welcome-kit-page/pageStore';
import { DropdownButtonStyled } from './styles';

const MoreDropdown: React.FC = observer(() => {
  const { welcomeLetterModalDelegate, confirmationLetterModalDelegate } = useWelcomeKitPageStore();

  const moreActionsDropdownOptions: DropdownOptionType[] = [
    {
      value: 'triggerAll',
      onOptionClick: (): void => welcomeLetterModalDelegate.open(),
      label: 'Trigger Welcome Letter',
    },
    {
      value: 'triggerAlliedConfirmationLetter',
      onOptionClick: (): void => confirmationLetterModalDelegate.open(),
      label: 'Trigger Confirmation Letter',
    },
  ];

  return (
    <Dropdown
      name="More"
      options={moreActionsDropdownOptions}
      optionsAlignment={OptionsAlignmentTypes.BOTTOM_LEFT}
      optionsWidth="25rem"
      closedElement={
        <DropdownButtonStyled color="primary" size="large" rightIconProp={<ChevronDown />}>
          MORE ACTIONS
        </DropdownButtonStyled>
      }
      openedElement={
        <DropdownButtonStyled color="primary" size="large" rightIconProp={<ChevronUp />}>
          MORE ACTIONS
        </DropdownButtonStyled>
      }
    />
  );
});

export default MoreDropdown;
